<template>
  <div class="w-full mx-auto px-10">
      <div class="pt-6 pb-6 flex justify-start">
          <p class="pr-2 text-costeaGray text-t14">Para actualizar la contraseña es necesario confirmar tu actual contraseña</p> 
      </div>
      <form action="#">
          <div class="grid grid-cols-2 gap-12">
              <div class="flex flex-col justify-center items-start">
                  <label for="password" class="text-costeaGray text-t14 relative leading-6">Contraseña actual</label>
                  <div class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none pr-2 rounded-md text-t14">
                    <input :type="typeControl" :name="password" id="password" class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="Contraseña">
                    <i @click="showPassword"  :class="iconShowPassword+' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
                  </div>
                  <a href="" class="text-costeaBlack mt-2 text-t12 font-costea hover:text-costeaHover self-end">Olvidé mi contraseña</a>
              </div>
          </div>
          <div class="grid grid-cols-2 gap-x-12 gap-y-1 mt-6">
              <h2 class="text-costeaBlack text-t14 uppercase col-span-full font-medium">Nueva Contraseña</h2>
              <div class="flex flex-col justify-center items-start mt-2">
                  <label for="newpassword" class="text-costeaGray text-t14 relative leading-6">Nueva contraseña</label>
                  <div class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none pr-2 rounded-md text-t14">
                    <input :type="typeControl" :name="newpassword" id="newpassword" class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="Nueva Contraseña">
                    <i @click="showPassword"  :class="iconShowPassword+' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
                  </div>
              </div>
              <div class="flex flex-col justify-center items-start mt-2">
                  <label for="newpasswordconfirm" class="text-costeaGray text-t14 relative leading-6">Confirmar contraseña</label>
                  <div class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none pr-2 rounded-md text-t14">
                    <input :type="typeControl" :name="newpasswordconfirm" id="newpasswordconfirm" class="bg-costeaContainer w-full h-10 flex justify-start items-center outline-none py-2 px-3 rounded-md text-t14" placeholder="Confirmar Contraseña">
                    <i @click="showPassword"  :class="iconShowPassword+' w-6 text-costeaGray h-full flex items-center content-center text-xl cursor-pointer'"></i>
                  </div>
              </div>
          </div>

          <div class="grid grid-cols-2 gap-x-12 gap-y-1 mt-6">
              <h2 class="text-costeaBlack text-t14 col-span-full font-medium">Condiciones de la contraseña</h2>
              <div class="flex flex-row justify-around items-start mt-2 col-span-full">
                  <ul class="w-2/4 leading-6 text-t14">
                      <li class="flex flex-row text-costeaGray"><i class="ri-checkbox-circle-fill text-costeaPrimaryDisabled mr-1"></i> Las contraseñas coinciden</li>
                      <li class="flex flex-row text-costeaGray"><i class="ri-checkbox-circle-fill text-costeaPrimaryDisabled mr-1"></i> Tiene más de 8 caracteres</li>
                      <li class="flex flex-row text-costeaGray"> <i class="ri-checkbox-circle-fill text-costeaPrimaryDisabled mr-1"></i>Tiene un número</li>
                  </ul>
                  <ul class="w-2/4 leading-6 text-t14">
                      <li class="flex flex-row text-costeaGray"><i class="ri-checkbox-circle-fill text-costeaPrimaryDisabled mr-1"></i> Tiene una letra en mayúscula</li>
                      <li class="flex flex-row text-costeaGray"><i class="ri-checkbox-circle-fill text-costeaPrimaryDisabled mr-1"></i> Tiene un cáracter especial</li>
                  </ul>
              </div>
          </div>
          
          <div class="mt-8 text-t12 flex justify-center mb-2">
              <button class="bg-costeaBtn2 px-7 py-3 rounded-md text-costeaPrimary mr-2 hover:bg-costeaBtn2Hover">Limpiar</button>
              <button class="bg-costeaPrimary px-7 py-3 rounded-md text-white ml-2 hover:bg-costeaHover">Actualizar</button>
          </div>
      </form>
  </div>
</template>
<script>
export default {
    data(){
      return{
        password: '',
        typeControl: 'password',
        iconShowPassword : 'ri-eye-off-line'
      }
    },
    methods: {
      //Mostrar contraseña y cambiar icono
      showPassword : function(){
        if(this.typeControl === "password"){
          this.typeControl = "text";
          this.iconShowPassword = "ri-eye-line";
        }else{
          this.typeControl = 'password';
          this.iconShowPassword = "ri-eye-off-line";
        }
      }
    },
}
</script>

<style>

</style>